import {
  ChangeDetectorRef,
  Component,
  computed,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { extractErrorList } from 'src/app/shared/helpers/utils';
import { ORIGINATOR_ID } from 'src/app/shared/enums/common.enum';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TooltipData_OpenTrade } from '../common/constants/tooltip.data';
import { TradeHttpService } from 'src/app/transactions/services/trade-http.service';
import {
  CCY_SORT_ORDER,
  ETR_TYPE,
} from 'src/app/shared/constants/helpers.const';
import { EtrInvoiceUploadComponent } from '../etr-invoice-upload/etr-invoice-upload.component';
import Swal from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import { AddDebtorCreditorComponent } from 'src/app/debtor-creditor/add-debtor-creditor/add-debtor-creditor.component';
import { BehaviorSubject } from 'rxjs';
import { AddEditContractComponent } from 'src/app/contracts/components/add-edit-contract/add-edit-contract.component';
import { ICredebtor } from './interface/i-credebtor';
import { OpenTradeComponentService } from './services/open-trade.component.service';
import { SpinnerService } from '../../shared/services/spinner.service';
import { Store } from '@ngrx/store';
import { selectCurrencyList } from '../../shared/state/selectors/currency.selector';

@Component({
  selector: 'app-open-trade',
  templateUrl: './open-trade.component.html',
  styleUrls: ['./open-trade.component.scss'],
  providers: [OpenTradeComponentService],
})
export class OpenTradeComponent implements OnInit {
  @ViewChild('fileUploaderTemplate') fileUploaderTemplate!: ElementRef;
  originatorId = ORIGINATOR_ID;
  currencyList: string[] = [];
  ccySortOrder = CCY_SORT_ORDER;
  @Input() pageTitle = '';
  pageTitleSignal = computed(() => this.componentService.pageTitle());
  @Input() currentData: any; // selected trade
  addForm: FormGroup;
  addForm2: FormGroup;
  remainingValue: string;
  isbEtr = false;
  tooltipData = TooltipData_OpenTrade;
  etrTypes = ETR_TYPE;
  selectedType = '';
  uploadedFiles: File | null = null;
  isFileSelected: boolean;
  years: { id: string; name: string }[] = [];
  creditorList: ICredebtor[] = [];
  debtorList: ICredebtor[] = [];
  showUploadLoaderTemplate = false;
  secondInterface = false;
  totalFaceValue = 0;
  hasCreditor: string;
  isEditTrade: boolean;
  readonly isLoading$ = new BehaviorSubject<boolean>(false);

  constructor(
    public activeModal: NgbActiveModal,
    private tradeTransactionsHttpService: TradeHttpService,
    private modalService: NgbModal,
    private apiClient: HttpClient,
    private componentService: OpenTradeComponentService,
    private spinnerService: SpinnerService,
    private store: Store,
    private ctr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.getCcyList();
    // this.componentService.pageTitle.set('Open a Trade');
    this.isLoading$.subscribe((isLoading) =>
      this.spinnerService.setShowSpinner(isLoading),
    );
  }

  private getCcyList(): void {
    this.store.select(selectCurrencyList).subscribe((currencyList) => {
      this.currencyList = [...currencyList].sort(
        (a, b) => this.ccySortOrder.indexOf(a) - this.ccySortOrder.indexOf(b),
      );
    });
  }

  onTypeChange(_event: Event): void {
    switch (this.selectedType) {
      case 'ms': {
        this.closeModal();
        const modalRef = this.modalService.open(AddEditContractComponent, {
          backdrop: true,
        });
        modalRef.componentInstance.currencyList = this.currencyList;
        modalRef.componentInstance.debtorList = this.debtorList;
        break;
      }
      case 'upload':
        Object.keys(this.addForm.controls).forEach((key) => {
          this.addForm.controls[key].clearValidators();
          this.addForm.controls[key].updateValueAndValidity();
        });
        break;
    }
  }

  handleEditByType(type: string) {
    this.hasCreditor = this.currentData.creditorId;

    if (type === 'RSA') {
      this.selectedType = this.hasCreditor ? 'b-ETR' : 'd-ETR';
    }
    this.ctr.detectChanges();
  }

  private extractError(err: any): string {
    const messages: any = typeof err === 'string' ? err : extractErrorList(err);
    const paragraphs =
      typeof err === 'string'
        ? messages
        : messages.map((item: any) => `<p>${item}</p>`);
    return typeof err === 'string' ? paragraphs : paragraphs.join('\n');
  }

  openTradeModal(title: string, formData: any) {
    const modalRef = this.modalService.open(EtrInvoiceUploadComponent, {
      backdrop: true,
    });
    modalRef.componentInstance.pageTitle = title;
    modalRef.componentInstance.formData = formData;
    modalRef.componentInstance.debtorList = this.debtorList;
    modalRef.componentInstance.creditorList = this.creditorList;
    modalRef.componentInstance.previousEtrType = formData.type;
  }

  closeModal(isUpdated?: boolean) {
    this.activeModal.dismiss(isUpdated);
  }

  downloadTemplate() {
    const filename = 'Open_Trade_Template.csv';
    const apiUrl = 'assets/resources/Open_Trade_Template.csv';
    this.apiClient
      .get(apiUrl, { responseType: 'arraybuffer' })
      .subscribe((data: ArrayBuffer) => {
        const blob = new Blob([data], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }

  selectTemplate(element: any) {
    this.uploadedFiles = element.target.files[0];
    this.isFileSelected = true;
  }

  uploadTemplate() {
    if (this.uploadedFiles) {
      this.showUploadLoaderTemplate = true;
      this.tradeTransactionsHttpService
        .acquisitionImport(this.uploadedFiles)
        .subscribe(
          (event: any) => {
            setTimeout(() => {
              this.showUploadLoaderTemplate = false;
              this.modalService.dismissAll();
              Swal.fire({
                icon: 'success',
                text: 'File successfully Uploaded.',
                showConfirmButton: true,
                confirmButtonText: 'Ok',
              });
              this.uploadedFiles = null;
              this.fileUploaderTemplate.nativeElement.value = null;
            }, 200);
          },
          (error) => {
            this.showUploadLoaderTemplate = false;
            this.uploadedFiles = null;
            this.fileUploaderTemplate.nativeElement.value = null;
            if (error.error.message.includes('Invalid Opening Quote')) {
              Swal.fire({
                icon: 'error',
                html: 'Invalid Data. Please check',
                text: 'Error',
                showConfirmButton: true,
                confirmButtonText: 'Ok',
              });
            } else {
              Swal.fire({
                icon: 'error',
                html: this.extractError(
                  error.error.details || error.error.message,
                ),
                text: 'Error',
                showConfirmButton: true,
                confirmButtonText: 'Ok',
              });
            }
          },
        );
    } else {
      Swal.fire({
        icon: 'error',
        html: 'Please select a file.',
        text: 'Error',
        showConfirmButton: true,
        confirmButtonText: 'Ok',
      });
    }
  }

  newCredebtor(type: string) {
    const modalRef = this.modalService.open(AddDebtorCreditorComponent, {
      backdrop: true,
    });
    modalRef.componentInstance.type = type;
    modalRef.result.then((result) => {
      // this.getCredebtorOverviewList()
      // this.getEntityList();
      if (type == 'Debtor') {
        this.addForm.get('debtorId')?.setValue(result?.id);
      } else if (type == 'Creditor') {
        this.addForm.get('creditorId')?.setValue(result?.id);
      }
    });
  }
}
